import axios from "axios";
import { toast } from "react-hot-toast";
// import { all } from "redux-saga/effects";
import { authUserResponse } from "../../store/actions";
import { getCookie, storeObjectData } from "./cookies";
import { ssoConfig } from "../sso/config";
import store from "../../store";
import { UseDecrypt, UseEncrypt } from "../customHooks/CryptoHooks";
import { useNavigate } from "react-router-dom";

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
// axios.defaults.baseURL = "https://devapiemagri.krihamegam.com/api/";
// axios.defaults.baseURL = "http://192.168.0.178:8080/api";

let customToken = [];
let customUser = [];

const handleRmdString = (payload, rmdString) => {
  // toast.success("Welcome Back To Success");
  const encryptedRmdDate = UseEncrypt(rmdString.toISOString());
  const encryptedPassword = UseEncrypt(payload?.password);
  storeObjectData("rmd", {
    rmd: encryptedRmdDate,
    password: encryptedPassword,
    userName: payload?.userName,
  });
};

const HandleAuthorise = (payload, rmdString) => {
  store.dispatch({
    type: "CREATE_AUTH",
    data: {
      payload: payload,
      callback: {
        success: () => handleRmdString(payload, rmdString), //Login(payload, rmdString),
      },
    },
  });
};
const handleSessionExp = () => {
  const parsedData = JSON.parse(getCookie("rmd"));
  // if (parsedData === null) {
  //   return handleLogout();
  // }
  const rmdString = UseDecrypt(parsedData?.rmd);
  const rmd = new Date(rmdString);
  const currentDate = new Date();
  const timeDifference = rmd - currentDate;
  const dayDifference = timeDifference / (1000 * 60 * 60 * 24);
  if (Math.round(dayDifference) > 0) {
    const payload = {
      username: parsedData?.userName,
      password: UseDecrypt(parsedData?.password),
    };
    HandleAuthorise(payload, rmdString);
  } else {
    handleLogout();
  }
};

let isHandlingSession = false;

const handleSessionExpcheck = () => {
  console.log("step 2");
  if (isHandlingSession) return;
  isHandlingSession = true;
  console.log("step 3");
  const parsedData = JSON.parse(getCookie("rmd"));
  console.log("step 4");
  if (parsedData === null) {
     console.log("step 5");
    return handleLogout();
  }

  const rmdString = UseDecrypt(parsedData?.rmd);
  const rmd = new Date(rmdString);
  const currentDate = new Date();
  const timeDifference = rmd - currentDate;
  const dayDifference = timeDifference / (1000 * 60 * 60 * 24);

  if (Math.round(dayDifference) > 0) {
    const payload = {
      email: parsedData?.userName,
      password: UseDecrypt(parsedData?.password),
    };
    HandleAuthorise(payload, rmdString);
  } else {
    handleLogout();
  }

  // Optional: Reset flag after some time (e.g., after token refresh)
  setTimeout(() => {
    isHandlingSession = false;
  }, 3000); // adjust as needed
};

// The backend no longer issues tokens, so an expired session means signing in again via SSO.
const handlelogoutInRmd = () => handleLogout();

const handleLogout = () => {
  const token = localStorage.getItem("token");
  // const token = tokenStr ? JSON.parse(tokenStr) : null;

  try {
    if (!token) throw new Error("");
    const parsedData = JSON.parse(token);
    console.log("parsedData", parsedData);
    storeObjectData("token", null);
    storeObjectData("rmd", null);
    toast.error("Session Expired, Please Login");
    store.dispatch({ type: "LOGOUT_USER" });
  } catch (error) {
    storeObjectData("token", null);
    storeObjectData("rmd", null);
    toast.error("Session Expired, Please Login");
    store.dispatch({ type: "LOGOUT_USER" });
    // console.error("Failed to parse token:", error.message);
  }
};

let refreshing = null;
const refreshAccessToken = (refreshToken) => {
  if (!refreshing) {
    refreshing = axios
      .post(
        ssoConfig.refreshUrl,
        { client_id: ssoConfig.clientId, refresh_token: refreshToken },
        {
          baseURL: "",
          _retried: true,
          transformRequest: [(d, h) => { delete h.Authorization; return JSON.stringify(d); }],
          headers: { "Content-Type": "application/json" },
        }
      )
      .then(({ data }) => {
        localStorage.setItem("token", data.access_token);
        if (data.refresh_token) localStorage.setItem("refresh_token", data.refresh_token);
        return data.access_token;
      })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
};

axios.interceptors.response.use(
  (response) => {
    return response?.response || response;
  },
  (error) => {
    const original = error?.config;
    if (error?.response?.status === 401) {
      const refreshToken = getCookie("refresh_token");
      if (original && !original._retried && refreshToken && refreshToken !== "null") {
        original._retried = true;
        return refreshAccessToken(refreshToken)
          .then((token) => {
            original.headers.Authorization = `Bearer ${token}`;
            return axios(original);
          })
          .catch(() => {
            handlelogoutInRmd();
            return Promise.reject(error?.response || error);
          });
      }
      handlelogoutInRmd();
    }
    // New backend modules answer {status, code, message}; hide-worthy role errors get one clear toast.
    const body = error?.response?.data;
    if (error?.response?.status === 403 && body?.code) {
      toast.error(
        body.code.startsWith("ADMIN_ROLE")
          ? "You do not have permission for this action"
          : body.message || body.code,
        { id: body.code }
      );
    }
    return Promise.reject(error?.response || error);
  }
);

export const axiosPost = async (api, payload) => {
  const token = getCookie("token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return axios.post(api, payload);
};

export const axiosPostNoAuth = (api, payload) => {
  return axios.post(api, payload);
};

export const axiosPut = async (api, payload) => {
  const token = getCookie("token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return axios.put(api, payload);
};

export const axiosPatch = async (api, payload) => {
  const token = getCookie("token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return axios.patch(api, payload);
};

export const axiosGet = async (api, payload) => {
  const token = getCookie("token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return axios.get(api, payload);
};

export const axiosDelete = async (api, payload) => {
  const token = getCookie("token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return axios.delete(api, {
    data: payload,
  });
};
